import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

// Components
import PageInfo from '../../pageinfo/PageInfo'
import Loading from '../../loading/Loading'
import Sidebar from '../../sidebar/Sidebar'

// JS
import {
  fetchPageFromBackend
} from '../../../utils/rest'
import { DESKTOPTABLETDEVICEWIDTH } from '../../../utils/constants'

// CSS
import './Page.css'

class Page extends Component {

  static propTypes = {
    news: PropTypes.array.isRequired,
    exhibitions: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      page: null
    }
  }

  componentWillMount() {
    this.fetchPage(this.props.match.params.string)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.string !== this.props.match.params.string) {
      this.fetchPage(this.props.match.params.string)
    }
  }

  render() {
    if (this.state.page) {
      return (
        <div className="details extra-margin">

          <PageInfo
            title={this.state.page.title}
            description={this.state.page.page_description}
          />

          <div className="page-content">
            <h3>{this.state.page.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: this.state.page.body_text }} />
          </div>
          <MediaQuery minDeviceWidth={DESKTOPTABLETDEVICEWIDTH}>
            <Sidebar
              news={this.props.news}
            />
          </MediaQuery>
        </div>
      )
    } else {
      return (
        <Loading
          title={"page"}
        />
      )
    }
  }

  receivePageError = (error) => {
    this.setState({ loading: false, error })
  }

  receivePageSuccess = (page) => {
    this.setState({ loading: false, page })
  }

  requestPage = () => {
    this.setState({ loading: true })
  }

  /**
   * Fetch page from backend and set them in redux store
   */
  async fetchPage(url) {

    try {
      this.requestPage()

      const page = await fetchPageFromBackend(url)

      this.receivePageSuccess(page)
    }
    catch (err) {
      this.receivePageError(err)
    }

  }

}

export default Page;


// WEBPACK FOOTER //
// ./src/components/main/page/Page.js